import { Dictionary, get, isObject, isString } from 'lodash';
import { AccessLevel } from 'src/app/core/enums/AccessLevels';
import { UserRole } from 'src/app/core/enums/UserRole';
import { ErrorResponse } from 'src/app/core/models/common.models';
import lang from 'src/assets/i18n/en.json';
import { environment } from 'src/environments/environment';

const errorCodes: Dictionary<string> = lang.errors;

export function getOrderIndex(prev?: any, next?: any, key = 'orderIndex', mul = 1): number {
  if (prev && next) {
    return (Number.parseFloat(prev[key]) + Number.parseFloat(next[key])) / 2;
  }

  if (prev) {
    return Number.parseFloat(prev[key]) + 1000 * mul;
  }

  if (next) {
    return Number.parseFloat(next[key]) - 1000 * mul;
  }

  return -Date.now();
}

export const getDomainCluster = () => {
  const domain = window.location.hostname;
  return domain.endsWith(`feedback${getQaServer()}.craft.io`) ? '-eu' : '';
};

export const getQaServer = (): string => {
  if ((environment as any).qaServer) {
    return (environment as any).qaServer;
  }

  const domain = window.location.hostname;
  const match = domain.match(/(-pp\d+|-dev)/i);
  return match?.[1] || '';
};

export const getCoreDomain = () => {
  return `app${getDomainCluster()}${getQaServer()}.craft.io`;
};

export function getAppUrl(subUrl?: string, productId?: string, itemId?: string): string {
  const domain = getCoreDomain();

  if (subUrl && productId && itemId) {
    return `//${domain}/${subUrl.replace('@productId', productId).replace('@itemId', itemId)}`;
  }

  if (subUrl && productId) {
    return `//${domain}/${subUrl.replace('@productId', productId)}/`;
  }

  return `//${domain}`;
}

export function authorize(accessLevel: AccessLevel, role: UserRole = UserRole.Anonymous): boolean {
  return (accessLevel & role) > 0;
}

export function getIdeaUrl(shortId?: string) {
  if (!window?.location?.origin || !shortId) {
    return shortId || '';
  }

  return window.location.origin + '/' + shortId;
}

export function parseServerError(res: unknown): ErrorResponse {
  const staus = get(res, 'status');

  let data: any;
  let code = staus || '';
  let message = isString(res) ? res : get(res, 'message') || get(res, 'statusText') || '';

  const errorData = isObject(res) ? get(res, 'error') : void 0;
  if (isObject(errorData)) {
    data = get(errorData, 'data');
    code = get(errorData, 'code') || get(data, 'code') || code;
    const msg = get(errorData, 'error') || get(errorData, 'message');
    message = isString(msg) ? msg : message;
  } else if (isString(errorData)) {
    message = errorData;
  }

  if (code && errorCodes[code]) {
    message = `errors.${code}`;
  } else if (message && errorCodes[message]) {
    message = `errors.${message}`;
  }

  return { status: staus || -1, code, message, data, wasCaught: true };
}
